<template>
	<div class="home">
		<div class="container">
			<div class="row">
				<div class="col-12 pt-4 pb-4 pl-md-0 pr-md-0">
					<div class="d-flex">
						<div class="pr-2">
							<img width="42px" src="/assets/icon/cara-berbelanja-icon.svg">
						</div>
						<div class="my-auto font-size-sm-16 font-size-20 text-uppercase font-weight-bold letter-spacing-2"><span class="color-gray-2">Cara</span><span class="pl-2 color-purple-light">Berbelanja</span></div>
					</div>
					<div class="pt-2 font-size-sm-12 font-size-15">
						<div>Untuk belanja di mobilecounter.mim.id silakan melakukan belanja sesuai panduan yang ada.<br> Untuk detailnya adalah sebagai berikut :</div>
					</div>
					<div class="pt-4 font-size-sm-11 font-size-12">
						<div class="font-weight-bold">Pilih Mobile Counter terdekat</div>
						<div>
							<div class="pt-2 d-flex">
								<div style="width:30px;">1.</div>
								<div style="width: fit-content;">Untuk memulai berbelanja bisa melakukan pemilihan Alamat Mobile Counter terdekat sesuai domisi Anda atau menginputkan nama/kode Mobile Counter.</div>
							</div>
							<div class="pt-2 d-flex">
								<div style="width:30px;">2.</div>
								<div style="width: fit-content;">Silakan memilih salah satu Mobile Counter dan klik tombol <span class="font-weight-bold color-purple-light">Beli Produk</span>.</div>
							</div>
							<div class="pt-2 d-flex">
								<div style="width:30px;">3.</div>
								<div style="width: fit-content;">Pilih salah satu produk yang akan Anda beli beserta jumlah  produk dengan klik tombol <span class="font-weight-bold color-purple-light">Masukkan ke Keranjang</span>.</div>
							</div>
							<div class="pt-2 d-flex">
								<div style="width:30px;">4.</div>
								<div style="width: fit-content;">Untuk melihat produk yang dipesan silakan klik tombol<span class="font-weight-bold color-purple-light"> Lihat Keranjang</span> atau klik tombol <span class="font-weight-bold color-purple-light">icon keranjang belanja</span> di kanan atas.</div>
							</div>
							<div class="pt-2 d-flex">
								<div style="width:30px;">5.</div>
								<div style="width: fit-content;">
									<div>Akan muncul jumlah barang dan total harga produk yang akan Anda pesan.</div>
									<div style="width: fit-content;">&#8226; Anda bisa melakukan penambahan, pengurangan dan penghapusan produk.</div>
								</div>
							</div>
							<div class="pt-2 d-flex">
								<div style="width:30px;">6.</div>
								<div style="width: fit-content;">Pilih <span class="font-weight-bold color-purple-light">Proses Sekarang</span> untuk memproses Pemesanan Anda.</div>
							</div>
						</div>
					</div>
					<div class="pt-4 font-size-sm-11 font-size-12">
						<div class="font-weight-bold">Masuk ke Akun atau melakukan Pendaftaran</div>
						<div>
							<div class="pt-2 d-flex">
								<div style="width:30px;">1.</div>
								<div style="width: fit-content;">
									<div>Anda akan diarahkan untuk <span class="font-weight-bold color-purple-light">masuk ke Akun Milagros</span> atau melakukan <span class="font-weight-bold color-purple-light">Pendaftaran Mitra Baru</span>.</div>
									<div style="width: fit-content;">&#8226; Jika Anda sudah terdaftar menjadi Mitra Milagros, Anda tinggal memasukkan Kode Mitra ( GSxxx) beserta kata sandi Anda kemudian klik tombol <span class="font-weight-bold color-purple-light">Masuk</span>.</div>
									<div style="width: fit-content;">&#8226; Jika Anda belum terdaftar silakan melakukan <span class="font-weight-bold color-purple-light">Pendaftaran dengan klik tombol Daftar</span> dan inputkan data diri pada formulir pendaftaran yang tersedia kemudian klik tombol <span class="font-weight-bold color-purple-light">Selanjutnya</span>.</div>
								</div>
							</div>
						</div>
					</div>
					<div class="pt-4 font-size-sm-11 font-size-12">
						<div class="font-weight-bold">Pilih Metode Pengiriman</div>
						<div>
							<div class="pt-2 d-flex">
								<div style="width:30px;">1.</div>
								<div style="width: fit-content;">Setelah masuk ke Akun Milagros atau proses pendaftaran telah  selesai, silakan klik tombol <span class="font-weight-bold color-purple-light">Checkout</span>.</div>
							</div>
							<div class="pt-2 d-flex">
								<div style="width:30px;">2.</div>
								<div style="width: fit-content;">
									<div>Anda akan diarahkan melakukan pemilihan metode pengiriman.</div>
									<div style="width: fit-content;">&#8226; <span class="font-weight-bold color-purple-light">Diambil ke Mobile Counter</span> ( Pick Up ) jika Anda ingin mengambil ke Mobile Counter yang Anda pilih.</div>
									<div style="width: fit-content;">&#8226; <span class="font-weight-bold color-purple-light">Jasa Pengiriman</span> ( Courier ) jika Anda ingin menggunakan jasa ekspedisi yang tersedia.</div>
								</div>
							</div>
						</div>
					</div>
					<div class="pt-4 font-size-sm-11 font-size-12">
						<div class="font-weight-bold">Pembayaran</div>
						<div>
							<div class="pt-2 d-flex">
								<div style="width:30px;">1.</div>
								<div style="width: fit-content;">Setelah memilih metode pengiriman, akan muncul total Pembayaran Pemesanan Produk Milagros Anda dan bisa klik tombol <span class="font-weight-bold color-purple-light">Bayar Sekarang</span>.</div>
							</div>
							<div class="pt-2 d-flex">
								<div style="width:30px;">2.</div>
								<div style="width: fit-content;">Sebelum melakukan pembayaran, akan ada resume pemesanan Anda yang bisa dicek sebelum dilakukan pembayaran. Silakan pilih <span class="font-weight-bold color-purple-light">Metode Pembayaran</span> Anda dengan menggunakan Virtual Account ( BCA atau Mandiri ).</div>
							</div>
							<div class="pt-2 d-flex">
								<div style="width:30px;">3.</div>
								<div style="width: fit-content;">Setelah memilih Virtual Account klik tombol <span class="font-weight-bold color-purple-light">Bayar Sekarang</span> dan akan muncul Detail Transaksi yang memuat informasi No Virtual Account, Jumlah Dibayar dan rentang waktu yang masih tersedia untuk dilakukan pembayaran ( Anda diwajibkan transfer sesuai nominal yang tertera ).</div>
							</div>
						</div>
					</div>
					<div class="pt-4 font-size-sm-11 font-size-12">
						<div class="font-weight-bold">Status Transaksi</div>
						<div>
							<div class="pt-2 d-flex">
								<div style="width:30px;">1.</div>
								<div style="width: fit-content;">
									<div>Untuk melakukan pengecekan status transaksi Anda bisa melalui step berikut :</div>
									<div style="width: fit-content;">&#8226; Calon Mitra, bisa menggunakan Fitur <span class="font-weight-bold color-purple-light">Cek Status Transaksi</span> dengan menginputkan Kode Transaksi dan No Handphone.</div>
									<div style="width: fit-content;">&#8226; Untuk Mitra, bisa menggunakan Fitur Transaksi > Lihat Detail Transaksi ketika sudah sukses masuk ke Akun Milagros.</div>
								</div>
							</div>
						</div>
					</div>
					<div class="pt-4 font-size-sm-11 font-size-12">
						<div class="font-weight-bold">Pembatalan Pemesanan</div>
						<div>
							<div class="pt-2 d-flex">
								<div style="width:30px;">1.</div>
								<div style="width: fit-content;">Pembatalan Pemesanan bisa dilakukan ketika status Pemesanan Belum Dibayar.</div>
							</div>
							<div class="pt-2 d-flex">
								<div style="width:30px;">2.</div>
								<div style="width: fit-content;">Anda bisa melakukan Pembatalan dengan klik tombol Batal pada Fitur Cek Status Transaksi ( Calon Mitra ) dan Fitur Transaksi pada Mitra Milagros.</div>
							</div>
						</div>
					</div>
					<div class="pt-4 font-size-sm-11 font-size-12">
						<div class="font-weight-bold">Konfirmasi Penerimaan Produk</div>
						<div>
							<div class="pt-2 d-flex">
								<div style="width:30px;">1.</div>
								<div style="width: fit-content;">Pastikan Anda sudah menerima Produk yang dipesan ketika konfirmasi Penerimaan Barang.</div>
							</div>
							<div class="pt-2 d-flex">
								<div style="width:30px;">2.</div>
								<div style="width: fit-content;">Anda bisa melakukan penerimaan barang di menu Cek Status Transaksi > Konfirmasi Penerimaan Barang atau menggunakan Fitur Transaksi > Lihat Detail > Konfirmasi Penerimaan Barang.</div>
							</div>
							<div class="pt-2 d-flex">
								<div style="width:30px;">3.</div>
								<div style="width: fit-content;">Ketika konfirmasi penerimaan barang sudah berhasil, maka untuk Mobile Counter akan menerima dana transaksi atas pemesanan barang.</div>
							</div>
						</div>
					</div>
					<div class="pt-4 font-size-sm-12 font-size-15">
						<div>Selamat Berbelanja, SoulMila !
							<!-- <br>Untuk Ebook Panduan tata cara Belanja  secara lengkap bisa di unduh di tautan berikut : -->
						</div>
						<!-- <div class="font-italic"><a href="https://drive.google.com/file/d/1EevgyPA8SUuFB_7D-wbufQA8AffrTBPl/view" target="_blank">Cara Belanja Ecommerce Milagros</a></div> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	data () {
		return {
		}
	}
};
</script>